import { api } from "../base";
import type { IOrderFills, IRestingOrders } from "@pulse-ui/codegen-v2/generated_ts/resting_orders";
import type { IExecutionReport } from "@pulse-ui/codegen-v2/generated_ts/drop_copy";

export type { IOrderFills, IRestingOrders } from "@pulse-ui/codegen-v2/generated_ts/resting_orders";
export type { ITradeCaptureReport } from "@pulse-ui/codegen-v2/generated_ts/drop_copy";

export interface GetRestingOrdersParams {
  account_id?: string;
  status?: string;
  lifecycle?: "open" | "terminal";
  symbol?: string;
  limit?: number;
  token?: string;
}

const restingOrdersEndpoints = api.injectEndpoints({
  endpoints: (build) => ({
    getRestingOrders: build.query<IRestingOrders, GetRestingOrdersParams>({
      query: (params) => ({
        url: "/api/orders/v1/resting-orders",
        params,
      }),
      keepUnusedDataFor: 0,
    }),
    getRestingOrderFills: build.query<IOrderFills, { orderId: string }>({
      query: ({ orderId }) => ({
        url: `/api/orders/v1/resting-orders/${encodeURIComponent(orderId)}/fills`,
      }),
    }),
    cancelRestingOrder: build.mutation<IExecutionReport, { orderId: string }>({
      query: ({ orderId }) => ({
        url: `/api/orders/v1/resting-orders/${encodeURIComponent(orderId)}/cancel`,
        method: "POST",
      }),
    }),
  }),
});

export const {
  useGetRestingOrdersQuery,
  useLazyGetRestingOrdersQuery,
  useGetRestingOrderFillsQuery,
  useCancelRestingOrderMutation,
} = restingOrdersEndpoints;
